

import { Component,Prop, BaseMixins } from '@/lib';

import { domHelper } from '@/lib/utils'
import Hicon from '@/components/hicon/hicon.vue'


@Component({
  components:{Hicon}
})
export default class CollapsedMenu extends BaseMixins {
    name:string='CollapsedMenu';
    placement:string = 'right-end';
    @Prop({type:Object,default:{}}) parentItem:any;
    @Prop({type:String,default:'dark'}) theme:string;
    @Prop({type:Number}) iconSize:number;
    @Prop({type:Boolean,default:false}) hideTitle:boolean;
    @Prop({type:Number,default:16}) rootIconSize:number;

    get parentName () {
      return this.parentItem.name
    }
    get children () {
      return this.parentItem.children
    }

    get textColor () {
      return this.theme === 'dark' ? '#fff' : '#495060' 
    }

    showTitle (item) {
      return this.L(item.meta.title)
    }

    showChildren (item) {
      return item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways))
    }

  // getNameOrHref (item, children0) {
  //   return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
  // }

  getNameOrHref(item, children0) {
    let itemName: string = "";

    if (item.href) {
      itemName = `isTurnByHref_${item.href}`;
    } else if (children0) {
      let firstChild = item.children[0];
      if (firstChild.meta && firstChild.meta.defaultChild) {
        itemName = firstChild.meta.defaultChild;
      } else {
        itemName = firstChild.name;
      }
    } else if (item.meta && item.meta.defaultChild) {
      itemName = item.meta.defaultChild;
    } else {
      itemName = item.name;
    }
    return itemName;
  }

    handleClick (name) {
      this.$emit('on-click', name)
    }
    handleMousemove (event, children) {
      const { pageY } = event
      const height = children.length * 38
      const isOverflow = pageY + height < window.innerHeight
      this.placement = isOverflow ? 'right-start' : 'right-end'
    }

    mounted () {
        let dropDownRefs = this.$refs.dropdown as any;
        let dropdown = domHelper.findNodeUpperByClasses(dropDownRefs.$el, ['ivu-select-dropdown', 'ivu-dropdown-transfer'])
        if (dropdown) dropdown.style.overflow = 'visible'
    }
}

